import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const client = axios.create({ baseURL: `${API_URL}/reports` });
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const unwrap = (p) => p.then((r) => r.data).catch((e) => { throw e.response?.data || e; });

const ReportService = {
  summary: (params) => unwrap(client.get('/summary', { params })),
  ledger: (params) => unwrap(client.get('/ledger', { params })),
  gstHst: (params) => unwrap(client.get('/gst-hst', { params })),
  adjustments: (params) => unwrap(client.get('/adjustments', { params })),
  addAdjustment: (body) => unwrap(client.post('/adjustments', body)),
  updateAdjustment: (id, body) => unwrap(client.put(`/adjustments/${id}`, body)),
  deleteAdjustment: (id) => unwrap(client.delete(`/adjustments/${id}`)),
  filedReturns: () => unwrap(client.get('/filed-returns')),
  fileReturn: (body) => unwrap(client.post('/filed-returns', body)),
  backfillInvoices: () => unwrap(client.post('/backfill-invoices')),

  // CSV download — fetch as blob with auth, then hand the browser a file.
  async downloadCsv(report, params) {
    const res = await client.get('/export.csv', { params: { ...params, report }, responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
    const a = document.createElement('a');
    a.href = url;
    const cd = res.headers['content-disposition'] || '';
    a.download = (cd.match(/filename="?([^"]+)"?/) || [])[1] || `${report}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};

export default ReportService;
